export const Delay = (ms: number) => new Promise((resolve, reject) => setTimeout(resolve, ms));


export default Delay; 